module.exports = __webpack_public_path__ + "static/img/-s-5.b73bdf0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/-s-5.png
// module id = x3U+
// module chunks = 0